module.exports = __webpack_public_path__ + "static/media/CYB2.61b7c58a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/CYB2.jpg
// module id = 1532
// module chunks = 1